import moment from 'moment-timezone';

const today = moment().startOf('day');
const tomorrow = moment().startOf('day').add(1, 'days');

const getResultsWithLabels = (results = []) => {
  if (!results?.length) return [{ noResults: true }];
  const finalResults = [];
  let previousDate = null;

  results.forEach(program => {
    const { startDate } = program || {};
    const startOfDay = moment(startDate).startOf('day');

    // today
    if (startOfDay.toISOString() === today.toISOString()) {
      // stops from repeatedly adding today and tomorrow labels
      if (previousDate?.toISOString() !== today.toISOString()) {
        finalResults.push({ label: 'Today' });
      }
      // tomorrow
    } else if (startOfDay.toISOString() === tomorrow.toISOString()) {
      if (previousDate?.toISOString() !== tomorrow.toISOString()) {
        finalResults.push({ label: 'Tomorrow' });
      }
    } else if (startOfDay.toISOString() !== previousDate?.toISOString()) {
      finalResults.push({ label: moment(startDate).format('ddd MMM D') });
    }

    finalResults.push(program);
    previousDate = startOfDay;
  });

  return finalResults;
};

export default getResultsWithLabels;
